import { useEffect } from 'react';
import { toasts } from '../utils/toasts';

const DISMISSED_KEY = 'melodiza:ios-install-prompt-dismissed-v1';

/**
 * Detects iOS Safari (not standalone) and shows a one-time toast
 * prompting the user to add Melodiza to their Home Screen.
 * Persists dismissal in localStorage.
 */
export function IOSInstallPrompt() {
  useEffect(() => {
    // iOS Safari detection
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    // Not already installed as standalone
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    // Already dismissed
    const isDismissed = localStorage.getItem(DISMISSED_KEY) === '1';

    if (!isIOS || isStandalone || isDismissed) return;

    // Show toast after a short delay so the app finishes loading
    const timer = setTimeout(() => {
      toasts.info(
        'Ajoutez Melodiza à votre écran d\'accueil pour une meilleure expérience — appuyez sur Partager puis "Sur l\'écran d\'accueil".',
        {
          duration: 8000,
          onDismiss: () => {
            localStorage.setItem(DISMISSED_KEY, '1');
          },
          onAutoClose: () => {
            localStorage.setItem(DISMISSED_KEY, '1');
          },
        }
      );
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return null;
}
